import React from 'react';
import { Text as TextBase, TextProps } from '@bpba/ui-components';

type TextWithChildrenProps = TextProps &
  Pick<React.HTMLAttributes<HTMLElement>, 'style' | 'className' | 'id' | 'onClick'> & {
    children?: React.ReactNode;
    as?: React.ElementType | string;
  };

export const Text = (props: TextWithChildrenProps) => <TextBase {...(props as any)} />;
